import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["multiple"];
import * as React from 'react';
import SingleToast from './SingleToast';
import MultipleToast from './MultipleToast';

var ToastController = function ToastController(_ref) {
  var _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, multiple ? /*#__PURE__*/React.createElement(MultipleToast, props) : /*#__PURE__*/React.createElement(SingleToast, props));
};

export default ToastController;
//# sourceMappingURL=index.js.map